<template>
  <div
    class="menu_box border_bottom_dashed"
    style="border-top: none; border-bottom: none"
  >
    <div class="flex borderBottomDashed paddingAll20">
      <div class="title_shaixuan flex_jc_center">综合筛选</div>
      <div>
        <el-form :inline="true" :model="formData" class="demo-form-inline">
          <el-form-item class="select-inputs" style="margin-left:10px">
            <el-cascader
              :options="areaOptions"
              v-model="formData.domicile"
              :props="props1"
              placeholder="注册地"
              size="small"
            >
            </el-cascader>
          </el-form-item>
          <el-form-item class="select-inputs">
            <el-select
              size="small"
              v-model="formData.achievement"
              placeholder="业绩"
            >
              <el-option
                v-for="(item, index) in achievement"
                :key="index"
                :label="item.name"
                :value="item.no"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="select-inputs">
            <el-cascader
              :options="filings"
              v-model="formData.filings"
              :props="props1"
              placeholder="备案地"
              size="small"
            >
            </el-cascader>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
const url = process.env.VUE_APP_LOGINAPI
import { apiResignAll } from "@/api/apiResignAll"
import request from "@/http"
export default {
  name: "engineeringScreen",
  data() {
    return {
      areaOptions: [],
      domicile: [], //注册地
      filings: [], //备案地
      props1: {
        label: "name",
        value: "no",
        children: "children",
        expandTrigger: "hover"
      },
      achievement: [
        { name: "0-100万", no: 0 },
        { name: "100-500万", no: 1 },
        { name: "500-1000万", no: 2 },
        { name: "1000-5000万", no: 3 },
        { name: "5000万-1亿元", no: 4 },
        { name: "1亿元以上", no: 5 }
      ],
      formData: {
        achievement: "",
        filings: [],
        domicile: [],
        filingsFirstNo: "",
        filingsSecondNo: "",
        filingsSecondName: "",
        provinceNo: "",
        cityNo: "",
        areaNo: "",
        areaName:""
      }
    }
  },
  watch: {
    "formData.achievement": function (v) {
      let obj = this.achievement.filter(d => d.no == v)
      if (v !== "" && obj.length) {
        this.send(obj[0], "achievement")
      }
    },
    "formData.domicile": function (v) {
      let obj = {}
      if (v && v.length) {
        this.areaOptions.map(d => {
          if (d.no == v[0]) {
            this.formData.provinceNo = d.no
          }
          d.children.map(i => {
            if (i.no == v[1]) {
              this.formData.cityNo = i.no
            }
            if(i.children&&i.children.length){
              i.children.map(item => {
                if (item.no == v[2]) {
                  this.formData.areaNo = item.no
                  this.formData.areaName = item.name
                }
              })
            }
          })
        })
        obj.provinceNo = this.formData.provinceNo //省
        obj.cityNo = this.formData.cityNo //市
        obj.areaNo = this.formData.areaNo //区
        obj.name = this.formData.areaName
      }
      if (v !== ""&&Object.keys(obj).length!==0) {
        this.send(obj, "domicile")
      }
    },
    "formData.filings": function (v, o) {
      let obj = {}
      if (v && v.length) {
        this.filings.map(d => {
          if (d.no == v[0]) {
            this.formData.filingsFirstNo = d.no
          }
          d.children.map(i => {
            if (i.no == v[1]) {
              this.formData.filingsSecondNo = i.no
              this.formData.filingsSecondName = i.name
            }
          })
        })
        obj.filingsFirstNo = this.formData.filingsFirstNo
        obj.filingsSecondNo = this.formData.filingsSecondNo
        obj.name = this.formData.filingsSecondName
      }
      if (v !== ""&&Object.keys(obj).length!==0) {
        this.send(obj, "filings")
      }
    }
  },
  created() {
    this.getDomicile()
    this.getFilings()
  },
  methods: {
    /** @name 获取注册地 */
    async getDomicile() {
      let res = await apiResignAll.getLocation()
      this.areaOptions = res.data.data.data
    },

    /** @name 获取备案地 */
    async getFilings() {
      let res = await request.get(
        url + "/sgb-enterpriseservices/recordUnit/getListInfo"
      )
      if (res.data.code == 0) {
        this.filings = res.data.data
      }
    },
    /** @name 搜索单项 */
    send(obj, key) {
      if (key) obj.key = key
      //替换搜索项
      let type = -1
      this.$parent.$refs.screen.engineeringScreen.map((d, i) => {
        if (d.key == key) {
          type = i
        }
      })
      if (type > -1) {
        this.$parent.$refs.screen.engineeringScreen.splice(type, 1, obj)
        return
      }
      //添加搜索项
      this.$parent.$refs.screen.engineeringScreen.push(obj)
    },
    /** @name 清队单项 */
    close(item) {
      this.formData[item.key] = ""
    },
    /** @name 清空所有 */
    closeall() {
      this.formData = {
        achievement: "",
        filings: [],
        domicile: [],
        filingsFirstNo: "",
        filingsSecondNo: "",
        filingsSecondName: "",
        provinceNo: "",
        cityNo: "",
        areaNo: "",
        areaName:""
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.select-inputs{
  height: 30px;
  margin-top: 10px;
  // margin-left: 10px;
  /deep/.el-input__inner{
    width: 200px!important;
  }
}
/deep/.el-cascader .domicile .el-input.is-focus .el-input__inner {
  border-color: #b79255;
}
</style>
